/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { LowestPriceForOffers } from '../../models/lowest-price-for-offers';

export interface GetPricesForOffers$Params {

/**
 * IATA code for airport or city
 */
  departureLocationCode: string;

/**
 * IATA codes for airports or cities
 */
  destinationLocationCodes: Array<string>;

/**
 * Show prices starting from this date (yyyy-MM-dd)
 */
  departureDate: string;

/**
 * Number of days to search forward from given start date
 */
  numberOfDays: number;

/**
 * Length of stay
 */
  lengthOfStay?: string;

/**
 * Travel classes
 */
  travelClasses?: Array<string>;

/**
 * Request oneway trip
 */
  oneway?: boolean;
}

export function getPricesForOffers(http: HttpClient, rootUrl: string, params: GetPricesForOffers$Params, context?: HttpContext): Observable<DapiHttpResponse<LowestPriceForOffers>> {
  const rb = new DapiRequestBuilder(rootUrl, getPricesForOffers.PATH, 'get');

  if (params) {
    rb.query('departureLocationCode', params.departureLocationCode, {});
    rb.query('destinationLocationCodes', params.destinationLocationCodes, {"explode":false});
    rb.query('departureDate', params.departureDate, {});
    rb.query('numberOfDays', params.numberOfDays, {});
    rb.query('lengthOfStay', params.lengthOfStay, {});
    rb.query('travelClasses', params.travelClasses, {"explode":false});
    rb.query('oneway', params.oneway, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<LowestPriceForOffers>;
    }),
    catchErrorAsJson()
  );
}

getPricesForOffers.PATH = '/api/instantsearch/prices/offers';
